import { render, staticRenderFns } from "./ProofOfDeliveryTemplatePage.vue?vue&type=template&id=29241a4d&scoped=true&"
import script from "./ProofOfDeliveryTemplatePage.vue?vue&type=script&lang=js&"
export * from "./ProofOfDeliveryTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDeliveryTemplatePage.vue?vue&type=style&index=0&id=29241a4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29241a4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29241a4d')) {
      api.createRecord('29241a4d', component.options)
    } else {
      api.reload('29241a4d', component.options)
    }
    module.hot.accept("./ProofOfDeliveryTemplatePage.vue?vue&type=template&id=29241a4d&scoped=true&", function () {
      api.rerender('29241a4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ProofOfDelivery/ProofOfDeliveryTemplatePage.vue"
export default component.exports